"use client";

import React from "react";
import { Content, asText, asHTML } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { PrismicText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { Carousel, Card } from "@/components/ui/apple-cards-carousel";

/**
 * Props for `AppleCards`.
 */
export type AppleCardsProps = SliceComponentProps<Content.AppleCardsSlice>;

/**
 * Component for "AppleCards" Slices.
 */
const AppleCards = ({ slice }: AppleCardsProps) => {
  const { title, description: sectionDescription, cards: cardItems } = slice.primary;

  const cards = cardItems.map((item, index) => {
    const cardData = {
      src: isFilled.image(item.image) ? item.image.url : "",
      title: isFilled.richText(item.card_title)
        ? asHTML(item.card_title)
        : "",
      category: isFilled.keyText(item.kicker) ? item.kicker : "",
      description: isFilled.richText(item.description)
        ? asHTML(item.description)
        : "",
    };

    return <Card key={index} card={cardData} />;
  });

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-full py-16 sm:py-20 bg-blue-50"
    >
      <div className="container">
      {isFilled.richText(title) && (
        <h2 className="highlighter max-w-6xl font-sans text-3xl leading-tight font-normal sm:font-light text-blue-900 md:text-5xl dark:text-neutral-200 md:leading-tight" dangerouslySetInnerHTML={{ __html: asHTML(title) }} />
      )}
      {isFilled.richText(sectionDescription) && (
        <div className="max-w-5xl mt-4 text-base text-gray-600 md:text-lg">
          <PrismicText field={sectionDescription} />
        </div>
      )}
      </div>
      <Carousel items={cards} startPadding="pl-6 sm:pl-8 lg:pl-16 xl:pl-20 2xl:pl-24" />
    </section>
  );
};

export default AppleCards;
